module.exports = __webpack_public_path__ + "img/DealerIcons-Instagram-On.1772c70.jpg";